import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';
//import { AuthService } from './auth.service';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private readonly baseUrl = environment.coreapipath;


  constructor(
    private httpService: HttpService,
    private loaderService: LoaderService
    //private authService: AuthService
  ) {}

  // get<T>(path: string, searchParams?: object): Observable<T> {
  //   return this.httpService.get<T>(this.combinePaths(path), this.createHttpParams(searchParams));
  // }
  get<T>(path: string, searchParams?: { [key: string]: any } | undefined,showLoader: boolean = true): Observable<T> {
    if (showLoader) {
      this.loaderService.showLoader(true);  // Show loader if requested
    }
    return this.httpService.get<T>(this.combinePaths(path), this.createHttpParams(searchParams)).pipe(
      finalize(() => {
        if (showLoader) {
          this.loaderService.showLoader(false);  // Hide loader after the request completes
        }
      })
    );
  }
  post<T>(path: string, body: object = {},showLoader: boolean = true): Observable<T> {
    if (showLoader) {
      this.loaderService.showLoader(true);  // Show loader if requested
    }

    
    return this.httpService.post<T>(this.combinePaths(path), body).pipe(
      finalize(() => {
        if (showLoader) {
          this.loaderService.showLoader(false);  // Hide loader after the request completes
        }
      })
    );
  }

  put<T>(path: string, body: object = {}): Observable<T> {
    return this.httpService.put<T>(this.combinePaths(path), body);
  }

  delete<T>(path: string): Observable<T> {
    return this.httpService.delete<T>(this.combinePaths(path));
  }
  // private combinePaths(path: string): string {
  //   const baseUrl = this.baseUrl.endsWith('/') ? this.baseUrl.slice(0, -1) : this.baseUrl;
  //   const cleanedPath = path.startsWith('/') ? path.slice(1) : path;
  //   return `${baseUrl}/${cleanedPath}`;
  // }
  private combinePaths(path: string): string {
    // Ensure there is exactly one slash between base URL and path
    const normalizedPath = path.replace(/^\/+|\/+$/g, ''); // Remove leading and trailing slashes
    return `${this.baseUrl}/${normalizedPath}`;
}

  // private createHttpParams(params: object): HttpParams {
  //   let httpParams = new HttpParams();

  //   if (params) {
  //     Object.keys(params).forEach(key => {
  //       const value = params[key];
  //       if (value !== null && value !== undefined) {
  //         httpParams = httpParams.append(key, value.toString());
  //       }
  //     });
  //   }

  //   return httpParams;
  // }

  private createHttpParams(params: { [key: string]: any } | undefined): HttpParams {
    let httpParams = new HttpParams();
    if (params !== undefined) {
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach(item => {
            httpParams = httpParams.append(key, item.toString());
          });
        } else if (value !== null && value !== undefined) {
          httpParams = httpParams.append(key, value.toString());
        }
      });
    }
    return httpParams;
  }

}
